module.exports = __webpack_public_path__ + "img/logo-bfs.fc521ef4.png";